import { SVGProps } from 'react';

export const Import = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.49017 3.54921V12.4371H8.34451V3.54921L11.3977 6.60238L12.7087 5.29136L7.41734 0L2.12598 5.29136L3.437 6.60238L6.49017 3.54921Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9804 14.2915V16.1458H1.85434V14.2915H0V16.1458C0 17.1685 0.831672 18.0002 1.85434 18.0002H12.9804C14.0031 18.0002 14.8347 17.1685 14.8347 16.1458V14.2915H12.9804Z"
      fill="currentColor"
    />
  </svg>
);
